import React, { useEffect, useRef } from 'react';
import './Bookingtomulaqaat.css';
import { BsCalendarCheck } from 'react-icons/bs';
import { MdVerified } from 'react-icons/md';
import { HiUsers } from 'react-icons/hi';
import { FaStar } from 'react-icons/fa';

function Bookingtomulaqaat() {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Add animate class to trigger animation
            const cards = entry.target.querySelectorAll('.step-card');
            cards.forEach((card) => {
              card.classList.remove('animate');
              // Force reflow to restart animation
              void card.offsetWidth;
              card.classList.add('animate');
            });
          }
        });
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section className="booking-section" id="booking-section" ref={sectionRef}>
      <div className="booking-container">
        <div className="booking-badge">
          <span>From Booking to Mulaqaat</span>
        </div>
        
        <div className="booking-subtitle">
          <p>No awkward introductions. No expectations.</p>
          <p>Just a well-designed social experience.</p>
        </div>

        <svg className="connecting-line" viewBox="0 0 1920 300" preserveAspectRatio="none">
          <path d="M 0 150 Q 400 50, 800 150 Q 1200 250, 1600 150 Q 1760 100, 1920 150" stroke="#F69575" strokeWidth="3" fill="none" />
        </svg>

        <div className="steps-wrapper">
          <div className="step-card step-1">
            <div className="step-icon icon-1">
              <BsCalendarCheck size={35} color="#F69575" />
            </div>
            <h3 className="step-title">Book Your Spot</h3>
            <p className="step-description">
              Choose your event, book your ticket, and receive instant confirmation with all event details.
            </p>
            <div className="step-divider"></div>
            <span className="step-number">STEP 1</span>
          </div>

          <div className="step-card step-2">
            <div className="step-icon icon2">
              <MdVerified size={35} color="#F69575" />
            </div>
            <h3 className="step-title">Get Verified</h3>
            <p className="step-description">
              We maintain a curated, balanced crowd. Once booked, registrations are verified to ensure quality and comfort for everyone.
            </p>
            <div className="step-divider"></div>
            <span className="step-number">STEP 2</span>
          </div>

          <div className="step-card step-3">
            <div className="step-icon icon3">
              <HiUsers size={35} color="#F69575" />
            </div>
            <h3 className="step-title">Show Up & Connect</h3>
            <p className="step-description">
              Arrive at the venue, grab a drink, and ease into guided conversations and thoughtfully designed icebreakers.
            </p>
            <div className="step-divider"></div>
            <span className="step-number">STEP 3</span>
          </div>

          <div className="step-card step-4">
            <div className="step-icon icon4">
              <FaStar size={35} color="#F69575" />
            </div>
            <h3 className="step-title">Let the Experience Flow</h3>
            <p className="step-description">
              No pressure. No forced matches. Just conversations, shared moments, and space to connect naturally.
            </p>
            <div className="step-divider"></div>
            <span className="step-number">STEP 4</span>
          </div>
        </div>

      <a href="/events" className="explore-events-btn">
          Explore Upcoming Events
        </a>
      </div>
    </section>
  );
}

export default Bookingtomulaqaat;